import { useEffect, useState } from "react";
import { fnGetDataSet } from "@shared/api/restApi";
import { global } from "@shared/libs/Global";
import { ColumnConfig } from "@shared/components/GridV2/SnGridTypes";

// 이 폴더의 .tsx는 대시보드가 위젯으로 자동 수집(require.context)하므로 이 파일은 .ts로 둔다.

const NO_COLUMNS: ColumnConfig[] = [];

/**
 * 위젯 상세 그리드 컬럼 정의(sys_widgetgridcolumn)를 cd_grid별로 묶어 돌려준다.
 * 하단 합계는 sys_widgetgridcolumn.yn_sum = 'Y' 로 켠다.
 */
export const useWidgetGridColumns = (cdWidget?: string) => {
  const { userInfo } = global();
  const [columnsByGrid, setColumnsByGrid] = useState<
    Record<string, ColumnConfig[]>
  >({});

  useEffect(() => {
    if (!cdWidget) return;

    const fetchColumns = async () => {
      try {
        const data: any = await fnGetDataSet({
          id: "sn_sys_dsh_rep_001_02",
          params: { cd_firm: userInfo.cd_firm, cd_widget: cdWidget },
        });

        const grouped: Record<string, ColumnConfig[]> = {};
        (data?.[0] || []).forEach((row: any) => {
          const column: ColumnConfig = {
            ...row,
            // SnGrid가 cd_menu/cd_user를 컨텍스트 메뉴 조회 키로 쓴다.
            cd_menu: "SN_SYS_DSH_REP_001",
            cd_user: userInfo.cd_user,
          };
          if (!grouped[row.cd_grid]) grouped[row.cd_grid] = [];
          grouped[row.cd_grid].push(column);
        });
        setColumnsByGrid(grouped);
      } catch (error) {
        setColumnsByGrid({});
      }
    };

    fetchColumns();
  }, [cdWidget, userInfo.cd_firm, userInfo.cd_user]);

  // 매 렌더 새 배열을 만들면 SnGrid가 컬럼을 계속 다시 만들므로 빈 값은 고정 배열을 돌려준다.
  return (cdGrid: string) => columnsByGrid[cdGrid] || NO_COLUMNS;
};
